import { type RemoteTimezone } from '@/lib/utils/dates';
import {
  type FullSupportCourseTrack,
  type UrlEntry,
  type UrlRegion,
} from '@/types';
import { type CoursePageParams, type CoursePageParamsParsed } from './page';

export type CoursePages = `course/${FullSupportCourseTrack}`;

export const urls: Record<CoursePages, Partial<Record<UrlRegion, UrlEntry>>> = {
  'course/cy': {
    de: 'cybersecurity',
    'de-en': 'cybersecurity',
    es: 'ciberseguridad',
    'es-en': 'cybersecurity',
    fr: 'cybersecurite',
    'fr-en': 'cybersecurity',
    gb: 'cybersecurity',
    nl: 'cybersecurity',
    'nl-en': 'cybersecurity',
    pt: 'ciberseguranca',
    'pt-en': 'cybersecurity',
    ww: 'cybersecurity',
  },
  'course/da': {
    de: 'data-analytics',
    'de-en': 'data-analytics',
    es: 'data-analytics',
    'es-en': 'data-analytics',
    fr: 'data-analytics',
    'fr-en': 'data-analytics',
    gb: 'data-analytics',
    nl: 'data-analytics',
    'nl-en': 'data-analytics',
    pt: 'data-analytics',
    'pt-en': 'data-analytics',
    us: 'data-analytics',
    ww: 'data-analytics',
  },
  'course/ux': {
    de: 'ux-ui-design',
    'de-en': 'ux-ui-design',
    es: 'diseno-ux-ui',
    'es-en': 'ux-ui-design',
    fr: 'ux-ui-design',
    'fr-en': 'ux-ui-design',
    gb: 'ux-ui-design',
    nl: 'ux-ui-design',
    'nl-en': 'ux-ui-design',
    pt: 'ux-ui-design',
    'pt-en': 'ux-ui-design',
    us: 'ux-ui-design',
    ww: 'ux-ui-design',
  },
  'course/wd': {
    de: 'webentwicklung',
    'de-en': 'web-development',
    es: 'desarrollo-web',
    'es-en': 'web-development',
    fr: 'developpement-web',
    'fr-en': 'web-development',
    gb: 'web-development',
    nl: 'web-development',
    'nl-en': 'web-development',
    pt: 'programacao-web',
    'pt-en': 'web-development',
    us: 'web-development',
    ww: 'web-development',
  },
};

export const parseParams = (params: CoursePageParams) => {
  const { extraParams = [], ...initialParsedParams } = params;

  return (extraParams as string[]).reduce<CoursePageParamsParsed>(
    (parsedParams, pathPart, index) => {
      switch (pathPart) {
        case 'timezone': {
          return {
            ...parsedParams,
            timezone: extraParams[index + 1].replace(
              '-',
              '/'
            ) as RemoteTimezone,
          };
        }

        case 'user-country': {
          return {
            ...parsedParams,
            userCountry: extraParams[index + 1],
          };
        }

        default: {
          return parsedParams;
        }
      }
    },
    initialParsedParams
  );
};
